import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/I18nContext';
import './NotFound.css';

const NotFound = () => {
  const { t } = useT();

  return (
    <div className="not-found-page page-shell">
      <div className="container">
        <div className="not-found-shell">
          <span className="section-eyebrow">{t('notfound.eyebrow')}</span>
          <h1>404</h1>
          <h2>{t('notfound.heading')}</h2>
          <p>{t('notfound.body')}</p>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              {t('notfound.returnHome')}
            </Link>
            <Link to="/dashboard" className="btn btn-secondary">
              {t('notfound.openDashboard')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
